// import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <p>
          干就完了1
        </p>
      </header>
    </div>
  );
}

export default App;
